let resetTimer: ReturnType<typeof setTimeout> | null = null;

export const resetViewportZoom = (): void => {
    const viewport = document.querySelector<HTMLMetaElement>("meta[name='viewport']");
    if (!viewport) {
        return;
    }

    if (resetTimer !== null) {
        clearTimeout(resetTimer);
    }

    viewport.setAttribute("content", "initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, width=device-width");

    // Allow WebKit one layout pass to lock zoom before restoring max-scale.
    resetTimer = setTimeout(() => {
        viewport.setAttribute("content", "initial-scale=1.0, maximum-scale=5.0, minimum-scale=1.0, width=device-width");
        resetTimer = null;
    }, 100);
};
